import {
    ColorNeutralBlack,
    Spacing4,
    Spacing8,
    Spacing12,
    Spacing16,
    ColorHealth4
} from 'autogen/design-tokens/tokens';
import { ProductTabHighlightsModel } from 'autogen/swagger/all';
import Tag, { ITag } from 'components/generic/tag';
import React from 'react';
import styled from 'styled-components';
import { breakpoint, sizes } from 'variables';
import CertificationHighlights from './components/CertificationHighlights';

const HighlightContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin-bottom: ${Spacing12};
`;

const TeaserContent = styled.div`
    margin-bottom: ${Spacing16};
`;

const StyledTag = styled(Tag)`
    margin-right: ${Spacing4};
    margin-bottom: ${Spacing4};

    ${breakpoint.up(sizes.xxxl)} {
        margin-right: ${Spacing8};
        margin-bottom: ${Spacing8};
    }
`;

const StyledCertificationHighlights = styled(CertificationHighlights)`
    margin-bottom: ${Spacing16};
`;

export default function Highlights({ ...props }: ProductTabHighlightsModel): JSX.Element {
    const { highlights, teaserContent, certificationHighlights } = props;

    highlights.sort((a, b) => (a.sortOrder < b.sortOrder ? -1 : 1));

    return (
        <div>
            {!!highlights?.length && (
                <HighlightContainer>
                    {highlights.map((highlight) => {
                        const { text, type } = highlight;
                        const isConscious = type === 'Conscious';
                        const tagProps: ITag = {
                            backgroundColor: isConscious ? ColorHealth4 : undefined,
                            textColor: isConscious ? ColorNeutralBlack : undefined,
                            children: text
                        };

                        return <StyledTag {...tagProps} key={text} />;
                    })}
                </HighlightContainer>
            )}
            {!!certificationHighlights?.length && (
                <StyledCertificationHighlights highlights={certificationHighlights} />
            )}
            {teaserContent && <TeaserContent dangerouslySetInnerHTML={{ __html: teaserContent }} />}
        </div>
    );
}
